import { laatsteAfgeslotenWeken } from '../week';
import type { TrendLezing } from '../trend-context';
import { useWekenoverzicht, type TrendBron } from './useWekenoverzicht';

export type { TrendBron } from './useWekenoverzicht';

/** Vier plekken: de laatste vier afgesloten weken (besluit 20-10 #4, criterium 41). */
const AANTAL_WEKEN = 4;

/**
 * Het overzicht over weken voor het blokje "komt dit terug", één verzoek per pagina
 * (SPEC-meerweekenoverzicht-feedback CAP-6).
 *
 * Altijd de laatste vier afgesloten weken, ook als de gebruiker een oudere week bekijkt. `actief: false`
 * vraagt niets op.
 */
export function useTrend(bron: TrendBron, actief = true): TrendLezing {
  return useWekenoverzicht(bron, laatsteAfgeslotenWeken(new Date(), AANTAL_WEKEN), actief);
}
